export const LOAD_TIME_SLOT_LIST = 'fittest-booking/LOAD_TIME_SLOT_LIST';
export const LOAD_TIME_SLOT_LIST_SUCCESS =
  'fittest-booking/LOAD_TIME_SLOT_LIST_SUCCESS';
export const LOAD_TIME_SLOT_LIST_ERROR =
  'fittest-booking/LOAD_TIME_SLOT_LIST_ERROR';

export const HOLD_BOOKING_SLOT = 'fittest-booking/HOLD_BOOKING_SLOT';
export const HOLD_BOOKING_SLOT_SUCCESS =
  'fittest-booking/HOLD_BOOKING_SLOT_SUCCESS';
export const HOLD_BOOKING_SLOT_ERROR =
  'fittest-booking/HOLD_BOOKING_SLOT_ERROR';

export const RELEASE_BOOKING_SLOT = 'fittest-booking/RELEASE_BOOKING_SLOT';
export const RELEASE_BOOKING_SLOT_SUCCESS =
  'fittest-booking/RELEASE_BOOKING_SLOT_SUCCESS';
export const RELEASE_BOOKING_SLOT_ERROR =
  'fittest-booking/RELEASE_BOOKING_SLOT_ERROR';

export const BOOK_APPOINTMENT = 'fittest-booking/BOOK_APPOINTMENT';
export const BOOK_APPOINTMENT_SUCCESS =
  'fittest-booking/BOOK_APPOINTMENT_SUCCESS';
export const BOOK_APPOINTMENT_ERROR = 'fittest-booking/BOOK_APPOINTMENT_ERROR';

export const SAVE_SELECTED_BOOKING_SLOT =
  'fittest-booking/SAVE_SELECTED_BOOKING_SLOT';
export const SAVE_SELECTED_BOOKING_SLOT_SUCCESS =
  'fittest-booking/SAVE_SELECTED_BOOKING_SLOT_SUCCESS';
export const SAVE_SELECTED_BOOKING_SLOT_ERROR =
  'fittest-booking/SAVE_SELECTED_BOOKING_SLOT_ERROR';

export const CLEAR_SELECTED_BOOKING_SLOT =
  'fittest-booking/CLEAR_SELECTED_BOOKING_SLOT';
export const CLEAR_SELECTED_BOOKING_SLOT_SUCCESS =
  'fittest-booking/CLEAR_SELECTED_BOOKING_SLOT_SUCCESS';
export const CLEAR_SELECTED_BOOKING_SLOT_ERROR =
  'fittest-booking/CLEAR_SELECTED_BOOKING_SLOT_ERROR';

export const LOAD_BOOKING_DETAIL = 'fittest-booking/LOAD_BOOKING_DETAIL';
export const LOAD_BOOKING_DETAIL_SUCCESS =
  'fittest-booking/LOAD_BOOKING_DETAIL_SUCCESS';
export const LOAD_BOOKING_DETAIL_ERROR =
  'fittest-booking/LOAD_BOOKING_DETAIL_ERROR';
export const RESET_CURRENT_HOLDING_SLOT =
  'fittest-booking/RESET_CURRENT_HOLDING_SLOT';

export const RESET_TIME_SLOT_DATA = 'fittest-booking/RESET_TIME_SLOT_DATA';
